Questa prova contiene _10 domande_ ed è pensata per essere risolta in _50 minuti_. La prova consiste di quesiti a **scelta multipla** e quesiti a **domanda aperta numerica**, ed è divisa in tre parti:

- quesiti di **pensiero logico**,
- quesiti di **pensiero algoritmico**, e
- quesiti di interpretazione di **procedimenti procedurali** come diagrammi di flusso.

In ciascuna delle tre parti, i quesiti sono _indicativamente_ ordinati per difficoltà crescente. _Attenzione_: la difficoltà è spesso soggettiva! Se stai passando tanto tempo cercando di risolvere un quesito, considera di dare uno sguardo al successivo, o ai problemi di un’altra categoria!

## Punteggio

Tutti i quesiti a _scelta multipla_ presentano 5 opzioni, di cui **solo una** è corretta. Il punteggio assegnato per tali quesiti è:

- 5 punti per una risposta _corretta_;
- 1 punto per una risposta _in bianco_;
- 0 punti per una risposta _errata_.

Ogni _domanda aperta numerica_ richiede come risposta un numero intero (eventualmente negativo). Il punteggio assegnato per tali domande è:

- 5 punti per una risposta _corretta_;
- 0 punti per una risposta _errata_ o _in bianco_.

Attenzione che alcuni quesiti potrebbero contenere più domande, ciascuna valutata separatamente.
